import { useCallback, useEffect, useState } from 'react';

/**
 * The whole router. One real route — /@handle — does not justify a
 * dependency, and the server already serves index.html for any non-/api path,
 * so deep links work without touching Express.
 */
export function useRoute() {
  const [path, setPath] = useState(() => window.location.pathname);

  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const navigate = useCallback((next) => {
    if (next === window.location.pathname) return;
    window.history.pushState({}, '', next);
    setPath(next);
  }, []);

  // The handle an /@name URL is asking for, or null for the map itself.
  const handle = /^\/@[a-z0-9_]{1,20}$/i.test(path) ? path.slice(2).toLowerCase() : null;

  return { path, handle, navigate };
}
